import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Control, FieldErrors, useFieldArray, UseFormRegister } from "react-hook-form";
import { ProgramInputs } from "../../schemas/inputs";
import { EvaluationType } from "../../schemas/types";
import { EvaluationSectionComponent } from "./EvaluationSectionComponent";

interface EvaluationStageSectionsProps {
    stageIndex: number;
    control: Control<ProgramInputs>;
    register: UseFormRegister<ProgramInputs>;
    errors: FieldErrors<ProgramInputs>;
    evaluationType: EvaluationType;
}

export const EvaluationStageSections = ({ stageIndex, control, register, errors, evaluationType }: EvaluationStageSectionsProps) => {
    const { fields, append, remove } = useFieldArray({
        control,
        name: `evaluations.${stageIndex}.sections`
    });

    const addSection = () => {
        append({
            name: '',
            criteria: []
        });
    };

    return (
        <>
            {fields.map((field, sectionIndex) => (
                <EvaluationSectionComponent
                    key={field.id}
                    stageIndex={stageIndex}
                    sectionIndex={sectionIndex}
                    control={control}
                    register={register}
                    errors={errors}
                    evaluationType={evaluationType}
                    onDelete={() => {}}
                    onDuplicate={() => {}}
                />
            ))}
            <Row className="mt-3">
                <Col>
                    <Button type="button" onClick={addSection} className="d-flex align-items-center gap-2 bg-transparent text-primary border border-dashed border-primary">
                        <FontAwesomeIcon icon={['fas', 'plus']} />
                        Adicionar seção
                    </Button>
                </Col>
            </Row>
        </>
    );
};
